export default __webpack_public_path__ + "static/media/608.55403c3d.png";